import { decode, encode } from 'he';

export const encodeHtmlEntities = (text: string): string =>
  encode(text, {
    useNamedReferences: true,
  });

export const decodeHtmlEntities = (text: string): string => decode(text);

export const stripHtmlTags = (html: string): string => {
  const div = document.createElement('div');
  div.innerHTML = `${html}`;
  return div.textContent || div.innerText || `${html}`.replace(/<\/?[^>]+(>|$)/g, '') || '';
};

/**
 * Check if passed content is HTML
 * @param content - text
 * @returns true if the content is HTML
 */
export const isHtmlContent = (content: string): boolean => /<\/?[a-z][\s\S]*>/i.test(content);
